/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{font-size:.75rem;margin-bottom:10px}.password-message[_ngcontent-%COMP%]{font-size:.75rem;color:#9f9f9c}"];
export { styles as styles };
